


// // // // // import React from 'react';

// // // // // const Step3ReviewSubmit = ({ schoolInfo, documents, onBack, onSubmit }) => {
// // // // //   const renderInfo = (label, value) => (
// // // // //     <div className="flex items-start gap-2 text-sm">
// // // // //       <span className="w-44 font-medium text-gray-300">{label}:</span>
// // // // //       <span className="text-white break-words">{value || '—'}</span>
// // // // //     </div>
// // // // //   );

// // // // //   const renderFile = (label, file) => (
// // // // //     <div className="flex items-start gap-2 text-sm">
// // // // //       <span className="w-44 font-medium text-gray-300">{label}:</span>
// // // // //       <span className="text-green-400 break-words">
// // // // //         {Array.isArray(file)
// // // // //           ? file.map((f, idx) => <div key={idx}>{f?.name || 'Not uploaded'}</div>)
// // // // //           : file?.name || 'Not uploaded'}
// // // // //       </span>
// // // // //     </div>
// // // // //   );

// // // // //   return (
// // // // //     <div className="space-y-8">
// // // // //       {/* Section Title */}
// // // // //       <div className="text-center">
// // // // //         <h3 className="text-xl font-semibold text-white">Step 3: Review & Submit</h3>
// // // // //         <p className="text-gray-400 text-sm mt-1">
// // // // //           Please review all details before submitting your registration.
// // // // //         </p>
// // // // //       </div>

// // // // //       {/* School Info */}
// // // // //       <div className="bg-slate-800 p-6 rounded-lg border border-slate-700">
// // // // //         <h4 className="text-white text-lg font-medium mb-4">🏫 School Information</h4>
// // // // //         <div className="space-y-2">
// // // // //           {renderInfo('School Name', schoolInfo.name)}
// // // // //           {renderInfo('Description', schoolInfo.description)}
// // // // //           {renderInfo('Year of Establishment', schoolInfo.establishedYear)}
// // // // //           {renderInfo('Board Affiliation', schoolInfo.boardAffiliation)}
// // // // //           {renderInfo('Medium of Instruction', schoolInfo.medium)}
// // // // //           {renderInfo('Subscription Type', schoolInfo.subscriptionType)}
// // // // //           {renderInfo('Email', schoolInfo.email)}
// // // // //           {renderInfo('Contact Email', schoolInfo.contactEmail)}
// // // // //           {renderInfo('Phone Number', schoolInfo.phone)}
// // // // //           {renderInfo('Country', schoolInfo.country)}
// // // // //           {renderInfo('State', schoolInfo.state)}
// // // // //           {renderInfo('City / District', schoolInfo.city)}
// // // // //           {renderInfo('Full Address', schoolInfo.fullAddress)}
// // // // //           {renderInfo('Pincode', schoolInfo.pincode)}
// // // // //           {renderInfo('Landmark', schoolInfo.landmark || '—')}
// // // // //         </div>
// // // // //       </div>

// // // // //       {/* Documents */}
// // // // //       <div className="bg-slate-800 p-6 rounded-lg border border-slate-700">
// // // // //         <h4 className="text-white text-lg font-medium mb-4">📎 Uploaded Documents</h4>
// // // // //         <div className="space-y-2">
// // // // //           {renderFile('School Logo', documents.logo)}
// // // // //           {renderFile('Banner Image(s)', documents.banner)}
// // // // //           {renderFile('Registration Certificate', documents.registrationCert)}
// // // // //           {renderFile('Affiliation Letter', documents.affiliationLetter)}
// // // // //           {renderFile("Principal's ID", documents.principalID)}
// // // // //           {renderFile('PAN Card', documents.panCard)}
// // // // //         </div>
// // // // //       </div>

// // // // //       {/* Actions */}
// // // // //       <div className="flex justify-between pt-6">
// // // // //         <button
// // // // //           onClick={onBack}
// // // // //           className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
// // // // //         >
// // // // //           ← Back
// // // // //         </button>
// // // // //         <button
// // // // //           onClick={onSubmit}
// // // // //           className="px-6 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
// // // // //         >
// // // // //           🚀 Submit & Launch
// // // // //         </button>
// // // // //       </div>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default Step3ReviewSubmit;



// // // // import React, { useState } from 'react';
// // // // import { ArrowPathIcon } from '@heroicons/react/24/outline';
// // // // import SuccessMessage from './SuccessMessage'; // import the success component

// // // // const Step3ReviewSubmit = ({ schoolInfo, documents, onBack, onSubmit }) => {
// // // //   const [isSubmitting, setIsSubmitting] = useState(false);
// // // //   const [isSuccess, setIsSuccess] = useState(false);

// // // //   const handleFinalSubmit = async () => {
// // // //     setIsSubmitting(true);
// // // //     try {
// // // //       await onSubmit(); // Parent-provided async submit logic
// // // //       setIsSuccess(true); // Show success UI
// // // //     } catch (err) {
// // // //       console.error("Submission failed", err);
// // // //       alert("Something went wrong. Please try again.");
// // // //     } finally {
// // // //       setIsSubmitting(false);
// // // //     }
// // // //   };

// // // //   const renderInfo = (label, value) => (
// // // //     <div className="flex items-start gap-2 text-sm">
// // // //       <span className="w-44 font-medium text-gray-300">{label}:</span>
// // // //       <span className="text-white break-words">{value || '—'}</span>
// // // //     </div>
// // // //   );

// // // //   const renderFile = (label, file) => (
// // // //     <div className="flex items-start gap-2 text-sm">
// // // //       <span className="w-44 font-medium text-gray-300">{label}:</span>
// // // //       <span className="text-green-400 break-words">
// // // //         {Array.isArray(file)
// // // //           ? file.map((f, idx) => <div key={idx}>{f?.name || 'Not uploaded'}</div>)
// // // //           : file?.name || 'Not uploaded'}
// // // //       </span>
// // // //     </div>
// // // //   );

// // // //   if (isSuccess) {
// // // //     return <SuccessMessage schoolName={schoolInfo.name}  />;
// // // //   }

// // // //   return (
// // // //     <div className="space-y-8 relative">
// // // //       {/* Overlay loader */}
// // // //       {isSubmitting && (
// // // //         <div className="absolute inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 rounded-lg">
// // // //           <div className="flex flex-col items-center">
// // // //             <ArrowPathIcon className="w-12 h-12 text-emerald-400 animate-spin" />
// // // //             <p className="text-white mt-2 text-sm">Submitting, please wait...</p>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {/* Section Title */}
// // // //       <div className="text-center">
// // // //         <h3 className="text-xl font-semibold text-white">Step 3: Review & Submit</h3>
// // // //         <p className="text-gray-400 text-sm mt-1">
// // // //           Please review all details before submitting your registration.
// // // //         </p>
// // // //       </div>

// // // //       {/* School Info */}
// // // //       <div className="bg-slate-800 p-6 rounded-lg border border-slate-700">
// // // //         <h4 className="text-white text-lg font-medium mb-4">🏫 School Information</h4>
// // // //         <div className="space-y-2">
// // // //           {renderInfo('School Name', schoolInfo.name)}
// // // //           {renderInfo('Description', schoolInfo.description)}
// // // //           {renderInfo('Year of Establishment', schoolInfo.establishedYear)}
// // // //           {renderInfo('Board Affiliation', schoolInfo.boardAffiliation)}
// // // //           {renderInfo('Medium of Instruction', schoolInfo.medium)}
// // // //           {renderInfo('Subscription Type', schoolInfo.subscriptionType)}
// // // //           {renderInfo('Email', schoolInfo.email)}
// // // //           {renderInfo('Contact Email', schoolInfo.contactEmail)}
// // // //           {renderInfo('Phone Number', schoolInfo.phone)}
// // // //           {renderInfo('Country', schoolInfo.country)}
// // // //           {renderInfo('State', schoolInfo.state)}
// // // //           {renderInfo('City / District', schoolInfo.city)}
// // // //           {renderInfo('Full Address', schoolInfo.fullAddress)}
// // // //           {renderInfo('Pincode', schoolInfo.pincode)}
// // // //           {renderInfo('Landmark', schoolInfo.landmark || '—')}
// // // //         </div>
// // // //       </div>

// // // //       {/* Documents */}
// // // //       <div className="bg-slate-800 p-6 rounded-lg border border-slate-700">
// // // //         <h4 className="text-white text-lg font-medium mb-4">📎 Uploaded Documents</h4>
// // // //         <div className="space-y-2">
// // // //           {renderFile('School Logo', documents.logo)}
// // // //           {renderFile('Banner Image(s)', documents.banner)}
// // // //           {renderFile('Registration Certificate', documents.registrationCert)}
// // // //           {renderFile('Affiliation Letter', documents.affiliationLetter)}
// // // //           {renderFile("Principal's ID", documents.principalID)}
// // // //           {renderFile('PAN Card', documents.panCard)}
// // // //         </div>
// // // //       </div>

// // // //       {/* Actions */}
// // // //       <div className="flex justify-between pt-6">
// // // //         <button
// // // //           onClick={onBack}
// // // //           className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
// // // //         >
// // // //           ← Back
// // // //         </button>
// // // //         <button
// // // //           onClick={handleFinalSubmit}
// // // //           disabled={isSubmitting}
// // // //           className="px-6 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
// // // //         >
// // // //           🚀 Submit & Launch
// // // //         </button>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default Step3ReviewSubmit;


// // // import React, { useState } from 'react';
// // // import { ArrowPathIcon } from '@heroicons/react/24/outline';
// // // import SuccessMessage from './SuccessMessage'; // note: not redesigned here — see message below

// // // const Step3ReviewSubmit = ({ schoolInfo, documents, onBack, onSubmit }) => {
// // //   const [isSubmitting, setIsSubmitting] = useState(false);
// // //   const [isSuccess, setIsSuccess] = useState(false);

// // //   const handleFinalSubmit = async () => {
// // //     setIsSubmitting(true);
// // //     try {
// // //       await onSubmit();
// // //       setIsSuccess(true);
// // //     } catch (err) {
// // //       console.error("Submission failed", err);
// // //       alert("Something went wrong. Please try again.");
// // //     } finally {
// // //       setIsSubmitting(false);
// // //     }
// // //   };

// // //   const renderInfo = (label, value) => (
// // //     <div className="flex items-start gap-2 text-sm font-['Sora',sans-serif]">
// // //       <span className="w-44 shrink-0 font-medium text-[#5A6478]">{label}:</span>
// // //       <span className="text-[#101826] break-words">{value || '—'}</span>
// // //     </div>
// // //   );

// // //   const renderFile = (label, file) => (
// // //     <div className="flex items-start gap-2 text-sm font-['Sora',sans-serif]">
// // //       <span className="w-44 shrink-0 font-medium text-[#5A6478]">{label}:</span>
// // //       <span className="text-emerald-600 break-words">
// // //         {Array.isArray(file)
// // //           ? file.map((f, idx) => <div key={idx}>{f?.name || 'Not uploaded'}</div>)
// // //           : file?.name || 'Not uploaded'}
// // //       </span>
// // //     </div>
// // //   );

// // //   if (isSuccess) {
// // //     return <SuccessMessage schoolName={schoolInfo.name} />;
// // //   }

// // //   return (
// // //     <div className="space-y-8 relative">
// // //       {isSubmitting && (
// // //         <div className="absolute inset-0 bg-white/85 backdrop-blur-sm flex items-center justify-center z-50 rounded-xl">
// // //           <div className="flex flex-col items-center">
// // //             <ArrowPathIcon className="w-12 h-12 text-[#2E63B8] animate-spin" />
// // //             <p className="text-[#101826] font-['Sora',sans-serif] mt-2 text-sm">Submitting, please wait...</p>
// // //           </div>
// // //         </div>
// // //       )}

// // //       <div className="text-center">
// // //         <h3 className="font-['Sora',sans-serif] text-xl font-semibold text-[#101826]">Step 3: Review & Submit</h3>
// // //         <p className="text-[#5A6478] font-['Sora',sans-serif] text-sm mt-1">
// // //           Please review all details before submitting your registration.
// // //         </p>
// // //       </div>

// // //       {/* School Info */}
// // //       <div className="bg-[#F4F8FC] p-6 rounded-xl border border-[#E3E8F0]">
// // //         <h4 className="font-['Sora',sans-serif] text-[#101826] text-lg font-semibold mb-4">School information</h4>
// // //         <div className="space-y-2">
// // //           {renderInfo('School Name', schoolInfo.name)}
// // //           {renderInfo('Description', schoolInfo.description)}
// // //           {renderInfo('Year of Establishment', schoolInfo.establishedYear)}
// // //           {renderInfo('Board Affiliation', schoolInfo.boardAffiliation)}
// // //           {renderInfo('Medium of Instruction', schoolInfo.medium)}
// // //           {renderInfo('Subscription Type', schoolInfo.subscriptionType)}
// // //           {renderInfo('Email', schoolInfo.email)}
// // //           {renderInfo('Contact Email', schoolInfo.contactEmail)}
// // //           {renderInfo('Phone Number', schoolInfo.phone)}
// // //           {renderInfo('Country', schoolInfo.country)}
// // //           {renderInfo('State', schoolInfo.state)}
// // //           {renderInfo('City / District', schoolInfo.city)}
// // //           {renderInfo('Full Address', schoolInfo.fullAddress)}
// // //           {renderInfo('Pincode', schoolInfo.pincode)}
// // //           {renderInfo('Landmark', schoolInfo.landmark || '—')}
// // //         </div>
// // //       </div>

// // //       {/* Documents */}
// // //       <div className="bg-[#F4F8FC] p-6 rounded-xl border border-[#E3E8F0]">
// // //         <h4 className="font-['Sora',sans-serif] text-[#101826] text-lg font-semibold mb-4">Uploaded documents</h4>
// // //         <div className="space-y-2">
// // //           {renderFile('School Logo', documents.logo)}
// // //           {renderFile('Banner Image(s)', documents.banner)}
// // //           {renderFile('Registration Certificate', documents.registrationCert)}
// // //           {renderFile('Affiliation Letter', documents.affiliationLetter)}
// // //           {renderFile("Principal's ID", documents.principalID)}
// // //           {renderFile('PAN Card', documents.panCard)}
// // //         </div>
// // //       </div>

// // //       {/* Actions */}
// // //       <div className="flex justify-between pt-2">
// // //         <button
// // //           onClick={onBack}
// // //           className="px-6 py-2.5 bg-white border border-[#D8DEE9] hover:border-[#2E63B8] hover:text-[#2E63B8] text-[#5A6478] font-['Sora',sans-serif] font-semibold rounded-lg transition-colors duration-200"
// // //         >
// // //           ← Back
// // //         </button>
// // //         <button
// // //           onClick={handleFinalSubmit}
// // //           disabled={isSubmitting}
// // //           className="px-6 py-2.5 bg-[#E8A63C] hover:bg-[#D6952E] text-white font-['Sora',sans-serif] font-semibold rounded-lg transition-colors duration-200 shadow-sm disabled:opacity-50"
// // //         >
// // //           Submit & launch
// // //         </button>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default Step3ReviewSubmit;


// // import React, { useState } from 'react';
// // import { ArrowPathIcon } from '@heroicons/react/24/outline';
// // import SuccessMessage from './SuccessMessage'; // note: not redesigned here — see DESIGN_NOTES.md

// // const displayFont = { fontFamily: "'Fraunces', serif" };

// // const Step3ReviewSubmit = ({ schoolInfo, documents, onBack, onSubmit }) => {
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [isSuccess, setIsSuccess] = useState(false);

// //   const handleFinalSubmit = async () => {
// //     setIsSubmitting(true);
// //     try {
// //       await onSubmit();
// //       setIsSuccess(true);
// //     } catch (err) {
// //       console.error("Submission failed", err);
// //       alert("Something went wrong. Please try again.");
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   const renderInfo = (label, value) => (
// //     <div className="flex items-start gap-2 text-sm">
// //       <span className="w-44 shrink-0 font-medium text-[#5A6478]">{label}:</span>
// //       <span className="text-[#101826] break-words">{value || '—'}</span>
// //     </div>
// //   );

// //   const renderFile = (label, file) => (
// //     <div className="flex items-start gap-2 text-sm">
// //       <span className="w-44 shrink-0 font-medium text-[#5A6478]">{label}:</span>
// //       <span className="text-emerald-600 break-words">
// //         {Array.isArray(file)
// //           ? file.map((f, idx) => <div key={idx}>{f?.name || 'Not uploaded'}</div>)
// //           : file?.name || 'Not uploaded'}
// //       </span>
// //     </div>
// //   );

// //   if (isSuccess) {
// //     return <SuccessMessage schoolName={schoolInfo.name} />;
// //   }

// //   return (
// //     <div className="space-y-8 relative">
// //       {isSubmitting && (
// //         <div className="absolute inset-0 bg-white/85 backdrop-blur-sm flex items-center justify-center z-50 rounded-2xl">
// //           <div className="flex flex-col items-center">
// //             <ArrowPathIcon className="w-12 h-12 text-[#2E63B8] animate-spin" />
// //             <p className="text-[#101826] mt-2 text-sm">Submitting, please wait...</p>
// //           </div>
// //         </div>
// //       )}

// //       <div className="text-center -mt-2 mb-2">
// //         <h3 style={displayFont} className="text-xl text-[#101826]">Step 3: Review &amp; Submit</h3>
// //         <p className="text-[#5A6478] text-sm mt-1">
// //           Please review all details before submitting your registration.
// //         </p>
// //       </div>

// //       {/* School Info */}
// //       <div className="bg-white border border-[#E3E8F0] rounded-2xl p-6 shadow-[0_1px_2px_rgba(16,24,38,0.04)]">
// //         <h4 className="border-l-2 border-[#E8A63C] pl-3 text-[15px] font-semibold text-[#163863] mb-4">
// //           School information
// //         </h4>
// //         <div className="space-y-2">
// //           {renderInfo('School Name', schoolInfo.name)}
// //           {renderInfo('Description', schoolInfo.description)}
// //           {renderInfo('Year of Establishment', schoolInfo.establishedYear)}
// //           {renderInfo('Board Affiliation', schoolInfo.boardAffiliation)}
// //           {renderInfo('Medium of Instruction', schoolInfo.medium)}
// //           {renderInfo('Subscription Type', schoolInfo.subscriptionType)}
// //           {renderInfo('Email', schoolInfo.email)}
// //           {renderInfo('Contact Email', schoolInfo.contactEmail)}
// //           {renderInfo('Phone Number', schoolInfo.phone)}
// //           {renderInfo('Country', schoolInfo.country)}
// //           {renderInfo('State', schoolInfo.state)}
// //           {renderInfo('City / District', schoolInfo.city)}
// //           {renderInfo('Full Address', schoolInfo.fullAddress)}
// //           {renderInfo('Pincode', schoolInfo.pincode)}
// //           {renderInfo('Landmark', schoolInfo.landmark || '—')}
// //         </div>
// //       </div>

// //       {/* Documents */}
// //       <div className="bg-white border border-[#E3E8F0] rounded-2xl p-6 shadow-[0_1px_2px_rgba(16,24,38,0.04)]">
// //         <h4 className="border-l-2 border-[#E8A63C] pl-3 text-[15px] font-semibold text-[#163863] mb-4">
// //           Uploaded documents
// //         </h4>
// //         <div className="space-y-2">
// //           {renderFile('School Logo', documents.logo)}
// //           {renderFile('Banner Image(s)', documents.banner)}
// //           {renderFile('Registration Certificate', documents.registrationCert)}
// //           {renderFile('Affiliation Letter', documents.affiliationLetter)}
// //           {renderFile("Principal's ID", documents.principalID)}
// //           {renderFile('PAN Card', documents.panCard)}
// //         </div>
// //       </div>

// //       {/* Actions */}
// //       <div className="flex justify-between pt-2">
// //         <button
// //           onClick={onBack}
// //           className="px-7 py-3 rounded-full border border-[#D8DEE9] text-[#5A6478] font-semibold hover:border-[#2E63B8] hover:text-[#2E63B8] transition-colors duration-200"
// //         >
// //           ← Back
// //         </button>
// //         <button
// //           onClick={handleFinalSubmit}
// //           disabled={isSubmitting}
// //           className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-gradient-to-r from-[#E8A63C] to-[#D6952E] text-white font-semibold shadow-lg shadow-[#E8A63C]/30 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:hover:translate-y-0"
// //         >
// //           Submit &amp; launch
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Step3ReviewSubmit;
  

// import React, { useState } from 'react';
// import { ArrowPathIcon } from '@heroicons/react/24/outline';
// import SuccessMessage from './SuccessMessage'; // note: not redesigned here — see DESIGN_NOTES.md

// const displayFont = { fontFamily: "'Fraunces', serif" };

// const Step3ReviewSubmit = ({ schoolInfo, documents, onBack, onSubmit }) => {
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isSuccess, setIsSuccess] = useState(false);

//   const handleFinalSubmit = async () => {
//     setIsSubmitting(true);
//     try {
//       await onSubmit();
//       setIsSuccess(true);
//     } catch (err) {
//       console.error("Submission failed", err);
//       alert("Something went wrong. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const renderInfo = (label, value) => (
//     <div className="flex items-start gap-2 text-sm">
//       <span className="w-44 shrink-0 font-medium text-[#5A6478]">{label}:</span>
//       <span className="text-[#101826] break-words">{value || '—'}</span>
//     </div>
//   );

//   const renderFile = (label, file) => (
//     <div className="flex items-start gap-2 text-sm">
//       <span className="w-44 shrink-0 font-medium text-[#5A6478]">{label}:</span>
//       <span className="text-emerald-600 break-words">
//         {Array.isArray(file)
//           ? file.map((f, idx) => <div key={idx}>{f?.name || 'Not uploaded'}</div>)
//           : file?.name || 'Not uploaded'}
//       </span>
//     </div>
//   );

//   if (isSuccess) {
//     return <SuccessMessage schoolName={schoolInfo.name} />;
//   }

//   return (
//     <div className="space-y-8 relative">
//       {isSubmitting && (
//         <div className="absolute inset-0 bg-white/85 backdrop-blur-sm flex items-center justify-center z-50 rounded-2xl">
//           <div className="flex flex-col items-center">
//             <ArrowPathIcon className="w-12 h-12 text-[#2E63B8] animate-spin" />
//             <p className="text-[#101826] mt-2 text-sm">Submitting, please wait...</p>
//           </div>
//         </div>
//       )}

//       <div className="text-center -mt-2 mb-2">
//         <h3 style={displayFont} className="text-xl text-[#101826]">Step 3: Review &amp; Submit</h3>
//         <p className="text-[#5A6478] text-sm mt-1">
//           Please review all details before submitting your registration.
//         </p>
//       </div>

//       {/* School Info */}
//       <div className="bg-white border border-[#E3E8F0] rounded-2xl p-6 shadow-[0_1px_2px_rgba(16,24,38,0.04)]">
//         <h4 className="border-l-2 border-[#E8A63C] pl-3 text-[15px] font-semibold text-[#163863] mb-4">
//           School information
//         </h4>
//         <div className="space-y-2">
//           {renderInfo('School Name', schoolInfo.name)}
//           {renderInfo('Description', schoolInfo.description)}
//           {renderInfo('Year of Establishment', schoolInfo.establishedYear)}
//           {renderInfo('Board Affiliation', schoolInfo.boardAffiliation)}
//           {renderInfo('Medium of Instruction', schoolInfo.medium)}
//           {renderInfo('Subscription Type', schoolInfo.subscriptionType)}
//           {renderInfo('Email', schoolInfo.email)}
//           {renderInfo('Contact Email', schoolInfo.contactEmail)}
//           {renderInfo('Phone Number', schoolInfo.phone)}
//           {renderInfo('Country', schoolInfo.country)}
//           {renderInfo('State', schoolInfo.state)}
//           {renderInfo('City / District', schoolInfo.city)}
//           {renderInfo('Full Address', schoolInfo.fullAddress)}
//           {renderInfo('Pincode', schoolInfo.pincode)}
//           {renderInfo('Landmark', schoolInfo.landmark || '—')}
//         </div>
//       </div>

//       {/* Documents */}
//       <div className="bg-white border border-[#E3E8F0] rounded-2xl p-6 shadow-[0_1px_2px_rgba(16,24,38,0.04)]">
//         <h4 className="border-l-2 border-[#E8A63C] pl-3 text-[15px] font-semibold text-[#163863] mb-4">
//           Uploaded documents
//         </h4>
//         <div className="space-y-2">
//           {renderFile('School Logo', documents.logo)}
//           {renderFile('Banner Image(s)', documents.banner)}
//           {renderFile('Registration Certificate', documents.registrationCert)}
//           {renderFile('Affiliation Letter', documents.affiliationLetter)}
//           {renderFile("Principal's ID", documents.principalID)}
//           {renderFile('PAN Card', documents.panCard)}
//         </div>
//       </div>

//       {/* Actions */}
//       <div className="flex justify-between pt-2">
//         <button
//           onClick={onBack}
//           className="px-6 py-2.5 rounded-full border border-[#D8DEE9] text-[#5A6478] font-semibold hover:border-[#2E63B8] hover:text-[#2E63B8] transition-colors duration-200"
//         >
//           ← Back
//         </button>
//         <button
//           onClick={handleFinalSubmit}
//           disabled={isSubmitting}
//           className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-gradient-to-r from-[#E8A63C] to-[#D6952E] text-white font-semibold shadow-lg shadow-[#E8A63C]/30 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:hover:translate-y-0"
//         >
//           Submit &amp; launch
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Step3ReviewSubmit;


import React, { useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import SuccessMessage from './SuccessMessage'; // note: not redesigned here — see DESIGN_NOTES.md

const displayFont = { fontFamily: "'Fraunces', serif" };

const Step3ReviewSubmit = ({ schoolInfo, documents, onBack, onSubmit }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [submissionResult, setSubmissionResult] = useState(null); // NEW

  const handleFinalSubmit = async () => {
    setIsSubmitting(true);
    try {
      const result = await onSubmit();
      setSubmissionResult(result);
      setIsSuccess(true);
    } catch (err) {
      // The specific failure reason was already toasted inside onSubmit()
      // (duplicate email, missing document, network issue, etc.) —
      // no second alert needed, that would just stack on top of the toast.
      console.error('Submission failed', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderInfo = (label, value) => (
    <div className="flex items-start gap-2 text-sm">
      <span className="w-44 shrink-0 font-medium text-[#5A6478]">{label}:</span>
      <span className="text-[#101826] break-words">{value || '—'}</span>
    </div>
  );

  const renderFile = (label, file) => (
    <div className="flex items-start gap-2 text-sm">
      <span className="w-44 shrink-0 font-medium text-[#5A6478]">{label}:</span>
      <span className="text-emerald-600 break-words">
        {Array.isArray(file)
          ? file.map((f, idx) => <div key={idx}>{f?.name || 'Not uploaded'}</div>)
          : file?.name || 'Not uploaded'}
      </span>
    </div>
  );

  if (isSuccess) {
    return (
      <SuccessMessage
        schoolName={schoolInfo.name}
        message={submissionResult?.message}
        schoolId={submissionResult?.schoolId}
      />
    );
  }

  return (
    <div className="space-y-8 relative">
      {isSubmitting && (
        <div className="absolute inset-0 bg-white/85 backdrop-blur-sm flex items-center justify-center z-50 rounded-2xl">
          <div className="flex flex-col items-center">
            <ArrowPathIcon className="w-12 h-12 text-[#2E63B8] animate-spin" />
            <p className="text-[#101826] mt-2 text-sm">Submitting, please wait...</p>
          </div>
        </div>
      )}

      <div className="text-center -mt-2 mb-2">
        <h3 style={displayFont} className="text-xl text-[#101826]">Step 3: Review &amp; Submit</h3>
        <p className="text-[#5A6478] text-sm mt-1">
          Please review all details before submitting your registration.
        </p>
      </div>

      {/* School Info */}
      <div className="bg-white border border-[#E3E8F0] rounded-2xl p-6 shadow-[0_1px_2px_rgba(16,24,38,0.04)]">
        <h4 className="border-l-2 border-[#E8A63C] pl-3 text-[15px] font-semibold text-[#163863] mb-4">
          School information
        </h4>
        <div className="space-y-2">
          {renderInfo('School Name', schoolInfo.name)}
          {renderInfo('Description', schoolInfo.description)}
          {renderInfo('Year of Establishment', schoolInfo.establishedYear)}
          {renderInfo('Board Affiliation', schoolInfo.boardAffiliation)}
          {renderInfo('Medium of Instruction', schoolInfo.medium)}
          {renderInfo('Subscription Type', schoolInfo.subscriptionType)}
          {renderInfo('Email', schoolInfo.email)}
          {renderInfo('Contact Email', schoolInfo.contactEmail)}
          {renderInfo('Phone Number', schoolInfo.phone)}
          {renderInfo('Country', schoolInfo.country)}
          {renderInfo('State', schoolInfo.state)}
          {renderInfo('City / District', schoolInfo.city)}
          {renderInfo('Full Address', schoolInfo.fullAddress)}
          {renderInfo('Pincode', schoolInfo.pincode)}
          {renderInfo('Landmark', schoolInfo.landmark || '—')}
        </div>
      </div>

      {/* Documents */}
      <div className="bg-white border border-[#E3E8F0] rounded-2xl p-6 shadow-[0_1px_2px_rgba(16,24,38,0.04)]">
        <h4 className="border-l-2 border-[#E8A63C] pl-3 text-[15px] font-semibold text-[#163863] mb-4">
          Uploaded documents
        </h4>
        <div className="space-y-2">
          {renderFile('School Logo', documents.logo)}
          {renderFile('Banner Image(s)', documents.banner)}
          {renderFile('Registration Certificate', documents.registrationCert)}
          {renderFile('Affiliation Letter', documents.affiliationLetter)}
          {renderFile("Principal's ID", documents.principalID)}
          {renderFile('PAN Card', documents.panCard)}
        </div>
      </div>

      {/* Actions */}
      <div className="flex justify-between pt-2">
        <button
          onClick={onBack}
          className="px-6 py-2.5 rounded-full border border-[#D8DEE9] text-[#5A6478] font-semibold hover:border-[#2E63B8] hover:text-[#2E63B8] transition-colors duration-200"
        >
          ← Back
        </button>
        <button
          onClick={handleFinalSubmit}
          disabled={isSubmitting}
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-gradient-to-r from-[#E8A63C] to-[#D6952E] text-white font-semibold shadow-lg shadow-[#E8A63C]/30 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:hover:translate-y-0"
        >
          Submit &amp; launch
        </button>
      </div>
    </div>
  );
};

export default Step3ReviewSubmit;
